import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';

@Component({
  selector: 'app-custom-enhanced-vaccine',
  standalone: false,
  templateUrl: './custom-enhanced-vaccine.component.html',
  styleUrls: ['./custom-enhanced-vaccine.component.scss']
})
export class CustomEnhancedVaccineComponent {
  data: Observable<any> = this.component.data$;
  cardsList: any;
  constructor(public component: CmsComponentData<CmsBannerComponent>,public contentService: ContentService, public cd:ChangeDetectorRef) { }
  ngOnInit() {
    this.data.subscribe(res => {
      this.vaccineFeaturedResources(res);
    });
  }
  vaccineFeaturedResources(res: any) {
    const tilesList = res?.vaccineFeaturedResources?.split(" ");
    if (tilesList) {
      this.contentService.opeffeaturedResources(tilesList).subscribe((res: any) => {
        this.cardsList = res.component;
        this.cd.detectChanges();
      });
    }
  }
}
